import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { Email } from '@h2/features/help/email'

const HelpRoutes = () => {
  return (
    <Switch>
      <Route path="/help/email">
        <Email />
      </Route>
      <Route
        path="/help"
        component={() => {
          window.location.replace('/help/redirect')

          return null
        }}
      />
    </Switch>
  )
}

export default HelpRoutes
